import type { CSSProperties } from 'react';

/** Shared Gantt toolbar control sizing (header buttons, zoom, more menu). */
export const GANTT_TOOLBAR_BUTTON_RADIUS = 6;

export const GANTT_TOOLBAR_CONTROL_BORDER = '1px solid rgb(218, 221, 227)';

/** Match header Button / More menu label typography. */
export const GANTT_TOOLBAR_LABEL_STYLE: CSSProperties = {
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
};

export const ganttToolbarTriggerStyle: CSSProperties = {
  borderRadius: GANTT_TOOLBAR_BUTTON_RADIUS,
  border: GANTT_TOOLBAR_CONTROL_BORDER,
  background: 'var(--mantine-color-body)',
  padding: '6px 10px',
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1.2,
  height: 28,
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

export const ganttToolbarButtonProps = {
  size: 'xs' as const,
  radius: GANTT_TOOLBAR_BUTTON_RADIUS,
  styles: {
    root: {
      height: 28,
      minHeight: 28,
      paddingLeft: 10,
      paddingRight: 10,
      fontSize: 13,
      fontWeight: 600,
      border: GANTT_TOOLBAR_CONTROL_BORDER,
    },
  },
};
